var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-detail" }, [
    _c("div", { staticClass: "u-d-cont" }, [
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "item-name" }, [_vm._v("用户编号")]),
        _c("div", { staticClass: "item-cont" }, [
          _vm._v(_vm._s(_vm.userObj.num))
        ])
      ]),
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "item-name" }, [_vm._v("用户名")]),
        _c("div", { staticClass: "item-cont" }, [
          _vm._v(_vm._s(_vm.userObj.name))
        ])
      ]),
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "item-name" }, [_vm._v("所属机构")]),
        _c("div", { staticClass: "item-cont" }, [
          _vm._v(_vm._s(_vm.userObj.belongOrg))
        ])
      ]),
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "item-name" }, [_vm._v("当前机构")]),
        _c("div", { staticClass: "item-cont" }, [
          _vm._v(_vm._s(_vm.userObj.org))
        ])
      ]),
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "item-name" }, [_vm._v("职位")]),
        _c("div", { staticClass: "item-cont" }, [
          _vm._v(_vm._s(_vm.userObj.position))
        ])
      ]),
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "item-name" }, [_vm._v("联系方式")]),
        _c("div", { staticClass: "item-cont" }, [
          _vm._v(_vm._s(_vm.userObj.tel))
        ])
      ]),
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "item-name" }, [_vm._v("用户状态")]),
        _c("div", { staticClass: "item-cont" }, [
          _vm._v(_vm._s(_vm.userObj.status))
        ])
      ]),
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "item-name" }, [_vm._v("核心机构号")]),
        _c("div", { staticClass: "item-cont" }, [
          _vm._v(_vm._s(_vm.userObj.coreOrgNum))
        ])
      ]),
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "item-name" }, [_vm._v("机构编号")]),
        _c("div", { staticClass: "item-cont" }, [
          _vm._v(_vm._s(_vm.userObj.orgNum))
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }